import 'babel-polyfill'
import 'bootstrap'
import "./header"
// Styling
import '../scss/style.scss'

//swiper
import { tns } from "tiny-slider"
import Swiper, { Navigation, Pagination,Autoplay } from 'swiper';


// Fontawesome
import { dom, library } from '@fortawesome/fontawesome-svg-core'
import { faFacebookF, faTwitter, faInstagram, faLinkedinIn ,faLinkedin,faFacebookSquare,faTwitterSquare,faSquareXTwitter } from '@fortawesome/free-brands-svg-icons'
import { faPhone, faCircleInfo } from '@fortawesome/free-solid-svg-icons'

library.add(faFacebookF, faTwitter, faInstagram, faLinkedinIn, faPhone,faLinkedin,faFacebookSquare,faTwitterSquare,faCircleInfo,faSquareXTwitter)
dom.watch()
import $ from 'jquery';
window.$ = window.jQuery = $;
import 'slick-carousel'
// General
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
 }
jQuery(document).ready(function ($) {
    if ($('.login.wp-core-ui').length) {
        $('#user_login').attr('placeholder', 'Gebruikersnaam of e-mailadres');
        $('#user_pass').attr('placeholder', 'Wachtwoord')
    }
    let verticalType = document.querySelector(".type-swiper-vertical");
    if (verticalType) {
        // slick
        (function ($) {
            // Use $ as usual here, e.g.:
            $('.swiper.type-swiper-vertical').slick({
                infinite: true,
                vertical: true,
                dots: true,
                swipeToSlide: true,
                centerMode: true,
                draggable: true,
                swipeToSlide: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            vertical: false,
                            slidesToShow: 1,
                            centerPadding: "30px",
                            verticalSwiping: false,
                        }
                    }
                ],
                verticalSwiping: true,
                appendArrows: ".pagination-wrapper",
                appendDots: ".types-slider-vertical-pagination",
                slidesToShow: 3,
                nextArrow: `<div class="slick-next slick-arrow" aria-label="Volgende" type="button"></div>`,
                prevArrow: `<div class="slick-prev slick-arrow" aria-label="Vorige" type="button"></div>`,
            });
            $(".swiper.type-swiper-vertical").on("afterChange", (e, slick, slide) => {
                let currentSlide = document.querySelector(".type-swiper-vertical .slick-current .swiper-slide")
                document.querySelector(".types-slider-img").src = currentSlide.dataset.img;
            })
        })(jQuery);
    }
    let filterBtn = document.querySelector(".filter-btn");
    if (filterBtn) {
        filterBtn.addEventListener("click", e => {
            document.querySelector(".side-filter").classList.add("show")
            document.children[0].classList.add("navBlock")
        })
        let closeFilterBtn = document.querySelector(".filter-close")
        closeFilterBtn.addEventListener("click", e => {
            document.querySelector(".side-filter").classList.remove("show")
            document.children[0].classList.remove("navBlock")
        })
    }
    let pageheadSlide = document.querySelector(".type-swiper .swiper-wrapper");
    if (pageheadSlide) {
        (function ($) {
            // Use $ as usual here, e.g.:
            $(pageheadSlide).slick({
                autoplay: true,
                autoplaySpeed: 3000,
                infinite: true,
                dots: false,
                arrows: false,
                draggable: false,
                swipeToSlide: true,
                slidesToShow: 1,

            });
        })(jQuery);

    }
    if (document.querySelector(".nav-full")) {
        window.addEventListener("scroll", e => {
            if (window.scrollY === 0) {
                document.querySelector(".nav-full").classList.add("top")
            } else {
                document.querySelector(".nav-full").classList.remove("top")
            }
        })
    }

    $(".sidemenu-link.arrow-right").on("click", async(e) => {

        $(".sidemenu-link.arrow-right").removeClass("active");
        let target = e.target;
        target.classList.add("active")
        let linksList=document.querySelectorAll(".slide-menu-right .active .sidemenu-link");
        let rightImg=document.querySelector(".slide-menu-right-img");

        rightImg.classList.remove("active")
        for (let index = 0; index < linksList.length; index++) {
            linksList[index].classList.remove("active")
            await sleep(50);
        }
        let activeMenu=document.querySelector(".slide-menu-right .side-menu.active");
        if(activeMenu){
            activeMenu.classList.remove("active");
            activeMenu.classList.add("d-none");
        }

        
        rightImg.addEventListener("transitionend",()=>{
            rightImg.src = target.parentElement.dataset.img;
        },{once:true})
        document.querySelector(".slide-menu-right [data-menu-id='"+target.parentElement.dataset.id+"']").classList.add("active");
        document.querySelector(".slide-menu-right [data-menu-id='"+target.parentElement.dataset.id+"']").classList.remove("d-none");
        linksList=document.querySelectorAll(".slide-menu-right .active .sidemenu-link");
        for (let index = 0; index < linksList.length; index++) {
            linksList[index].classList.add("active")
            await sleep(50);
        }
        document.querySelector(".slide-menu-right-img").classList.add("active")
    })
    var mouseX = 0,
        mouseY = 0;
    var xp = 0,
        yp = 0;
    $(document).mousemove(function (e) {
        mouseX = e.pageX;
        mouseY = e.pageY - document.documentElement.scrollTop
    });
    let mouseInterval = setInterval(function () {
        if (mouseX == 0 && mouseY == 0) {
            xp += ((mouseX - xp) / 6) - 100;
            yp += ((mouseY - yp) / 6)
        } else {
            xp += ((mouseX - xp) / 6);
            yp += ((mouseY - yp) / 6)
        }
        $('#cursor').css({
            left: xp + 'px',
            top: yp + 'px',
        })
    }, 13)
    // Change mouse cursor on mousemove
    $('body').mousemove(function (e) {
        if ($('.change-cursor:hover').length != 0) {
            var classList = e.target.className.split(/\s+/);
            for (var i = 0; i < classList.length; i++) {
                if (classList[i].startsWith('cursor-')) {
                    var color = classList[i].split('-')[1];
                    $('body').removeClass(function (index, section) {
                        return (section.match(/(^|\s)cursor-\S+/g) || []).join(' ');
                    });
                    $('body').addClass('cursor-image-' + color);
                }
            }
        } else {
            $('body').removeClass(function (index, section) {
                return (section.match(/(^|\s)cursor-\S+/g) || []).join(' ');
            });
        }

        $('.slick-list.draggable').mouseenter(function () {
            $('#cursor').addClass('show-slider-cursor');
        });
        $('.slick-list.draggable').mouseleave(function () {
            $('#cursor').removeClass('show-slider-cursor');
        });
    });

    $('.shop-filter__filter .shop-filter__filter-title').click(function () {
        function toggleSlide(container, content, parent = null, closeState = "0") {
            if (!container.classList.contains('active')) {
                container.classList.add('active');

                var height = content.clientHeight;
                if (height == 0 || height == Number((content.style.height).replace("px", "")) || 0 == Number((content.style.height).replace("px", ""))) {
                    let children = content.children;
                    height = 0;
                    if (children.length > 0) {
                        Array.from(children).forEach(x => {
                            height += x.clientHeight;
                        })
                    }
                }
                content.style.height = closeState = "px";

                setTimeout(function () {
                    if (parent) {
                        parent.style.height = (height + 20) + "px";
                    }
                    content.style.height = height + "px";
                }, 0);
            } else {
                content.style.height = closeState + "px";
                if (parent) {
                    parent.style.height = (Number(closeState) + 20) + "px";
                }
                container.classList.remove('active');
            }
        };
        toggleSlide(this, this.nextElementSibling)
    })
    let applyBtn = document.querySelector(".shop-filter__bottom .apply")
    if (applyBtn) {
        applyBtn.addEventListener("click", e => {
            //do filtering / ajax
            let searchParams = new URLSearchParams()
            document.querySelectorAll(".shop-filter__filter :checked").forEach(x => {
                searchParams.append(x.name, x.value)
            });
            let url = window.location.origin + window.location.pathname + "?" + searchParams.toString();
            window.location.href = url.replace(/\/page\/\d\//,"");
        })
    }
    let resetBtn = document.querySelector(".shop-filter__bottom .reset")
    if (resetBtn) {
        resetBtn.addEventListener("click", e => {
            document.querySelectorAll(".shop-filter__filter input").forEach(x => x.checked = false)
            applyBtn.click()
        })
    }
    
    document.querySelectorAll(".heightFix").forEach(x => {
        x.style.height = x.clientHeight + "px";
    })
    let lastCollapsible;
    if ($('.collapsibles__item-header').length) {
        function toggleSlide(container) {
            let content = container.querySelector(".collapsibles__item-content");
            if (!container.classList.contains('active')) {
                container.classList.add('active');

                content.style.height = 'auto';

                var height = content.clientHeight + 'px';

                content.style.height = '0px';

                setTimeout(function () {
                    content.style.height = height;
                }, 0);
            } else {
                content.style.height = '0px';

                // content.addEventListener('transitionend', function () {
                container.classList.remove('active');
                // }, {
                //   once: true
                // });
            }
        };
        $('.collapsibles__item-header').click(function () {
            // $('.collapsibles__item').removeClass('active');
            if (typeof lastCollapsible !== typeof undefined && !lastCollapsible.isEqualNode(this)) {
                let container = lastCollapsible.parentElement;
                let content = container.querySelector(".collapsibles__item-content");
                content.style.height = '0px';

                // content.addEventListener('transitionend', function () {
                container.classList.remove('active');
            }
            // $(this).parent().toggleClass('active');
            toggleSlide(this.parentElement)

            lastCollapsible = this;

        });
        let tabBtns = document.querySelectorAll(".faq-cat");
        tabBtns.forEach(x => {
            x.addEventListener("click", e => {
                tabBtns.forEach(z => {
                    z.classList.remove("active");
                })
                x.classList.add("active")
                document.querySelectorAll(".faq-tab-content.active").forEach(x=>x.classList.remove("active"))
                document.querySelector(".faq-tab-content[data-id='" + x.dataset.id + "']").classList.add("active")
            })
        })
        let faqSelect = document.querySelector(".faq-cat-mob");
        if(faqSelect){
            faqSelect.addEventListener("change", e => {
                tabBtns.forEach(z => {
                    z.classList.remove("active");
                })
                document.querySelector(".faq-tab-content.active").classList.remove("active")
                document.querySelector(".faq-tab-content[data-id='" + faqSelect.value + "']").classList.add("active")
            })
        }
    }

    if ($('.machine-wrap').length) {
        function toggleSlide(container) {
            let content = container.querySelector(".hide-mob");
            if (!container.classList.contains('active')) {
                container.classList.add('active');

                content.style.height = 'auto';

                var height = content.clientHeight + 'px';

                content.style.height = '0px';

                setTimeout(function () {
                    content.style.height = height;
                }, 0);
            } else {
                content.style.height = '0px';

                // content.addEventListener('transitionend', function () {
                container.classList.remove('active');
                // }, {
                //   once: true
                // });
            }
        };
        $('.machine-top').click(function () {
            this.classList.toggle("active")
            // $('.collapsibles__item').removeClass('active');
            // if (typeof lastCollapsible !== typeof undefined && !lastCollapsible.isEqualNode(this)) {
            //     let container = lastCollapsible.closest(".machine-wrap");
            //     let content = container.querySelector(".hide-mob");
            //     content.style.height = '0px';

            //     // content.addEventListener('transitionend', function () {
            //     container.classList.remove('active');
            // }
            // $(this).parent().toggleClass('active');
            toggleSlide(this.closest(".machine-wrap"))

            lastCollapsible = this;

        });
    }
    if ($('.faq').length) {
        let tabBtns = document.querySelectorAll(".faq-tabs .btn-tab");
        tabBtns.forEach(x => {
            x.addEventListener("click", e => {
                tabBtns.forEach(z => {
                    z.classList.remove("active");
                })
                x.classList.add("active")
                document.querySelector(".faq-tab-content.active").classList.remove("active")
                document.querySelector(".faq-tab-content[data-id='" + x.dataset.id + "']").classList.add("active")
            })
        })
    }
    // let btnForm= document.querySelector("#btn-form")
    // if(btnForm){
    //     btnForm.addEventListener("click",e=>{
    //         btnForm.closest("form").querySelector("input[type='submit']").click()
    //     })
    // }
    document.querySelectorAll(".info-i").forEach(x=>{x.addEventListener("click",e=>{
        document.querySelector(x.dataset.bsTarget+" .modal-body").innerHTML= x.dataset.info;
    })})
    document.querySelectorAll(".product-swiper").forEach(x => {
        const swiper = new Swiper(x, {
            slidesPerView: 1.3,
            initialSlide: 0,
            spaceBetween: 30,
            modules: [Navigation, Pagination],
            // loop: true,
            breakpoints: {
                600:{
                    slidesPerView:2,
                },
                992: {
                    slidesPerView: 4,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                        enabled: true,

                    },
                }
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                enabled: true,

            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });

    })
    document.querySelectorAll(".landings-swiper").forEach(x => {
        const swiper = new Swiper(x, {
            slidesPerView: 1,
            initialSlide: 0,
            spaceBetween: 30,
            autoplay:{
                delay:5000,
            },
            modules: [Navigation, Pagination,Autoplay],
            loop: true,
            navigation: {
                nextEl: '.landingspage-button-next',
                prevEl: '.landingspage-button-prev',
                enabled: true,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });

    })
    document.querySelectorAll(".video-swiper").forEach(x => {
        const swiper = new Swiper(x, {
            slidesPerView: 1,
            initialSlide: 0,
            spaceBetween: 30,
            modules: [Navigation, Pagination],
            loop: true,
            navigation: {
                nextEl: '.video-button-next',
                prevEl: '.video-button-prev',
                enabled: true,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });

    })
    document.querySelectorAll(".brand-swiper").forEach(x => {
        const swiper = new Swiper(x, {
            slidesPerView: 2,
            initialSlide: 2,
            breakpoints: {
                2000: {
                    slidesPerView: 10,
                },
                1800: {
                    slidesPerView: 9,
                },
                1600: {
                    slidesPerView: 8,
                },
                1400: {
                    slidesPerView: 7,
                },
                1200: {
                    slidesPerView: 6,
                },
                1000: {
                    slidesPerView: 6,
                },
                992: {
                    slidesPerView: 5,
                },
                700: {
                    slidesPerView: 4,
                },
                500: {
                    slidesPerView: 3,
                },
            },
            spaceBetween: 30,
            modules: [Pagination],
            // loop: true,
            centeredSlides: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
        });

    })
    document.querySelectorAll(".tabs .tab").forEach(x => {
        x.addEventListener("click", e => {
            document.querySelector(".tabs .tab.active").classList.remove("active")
            x.classList.add("active")
            document.querySelector(".tabs-wrapper .tab-content").innerHTML = x.dataset.content;
        })
    })
    let nextFormBtn = document.querySelector(".form .btn-next-step")
    if (nextFormBtn) {
        nextFormBtn.addEventListener("click", e => {
            let nextStepTab = document.querySelector(".form .step-tabs .step2")
            let nextStep = document.querySelector(".form .step2.step-holder")
            let currentStepTab = document.querySelector(".form .step-tabs .step1")
            let currentStep = document.querySelector(".form .step1.step-holder")
            let errors = false;
            function showErrors() {
                currentStep.querySelectorAll("input:valid ,select:valid , textarea:valid").forEach(
                    x => {
                        x.classList.add("valid")
                        x.classList.remove("invalid")
                        x.parentElement.classList.remove("invalid")
                    }
                )
                currentStep.querySelectorAll("input:invalid ,select:invalid , textarea:invalid").forEach(
                    x => {
                        x.classList.add("invalid")
                        x.parentElement.classList.add("invalid")
                        x.oninput= function(e){
                            if(e.currentTarget.checkValidity){
                                x.classList.remove("invalid")
                                x.parentElement.classList.remove("invalid")
                                e.currentTarget.oninput=null
                                
                            }
                        }
                    }
                )
            }
            showErrors()
            
            currentStep.querySelectorAll("input,select,textarea").forEach(x => {
                if (x.ariaRequired === "true") {
                    x.required = true;
                }
                if (!x.checkValidity()) {
                    errors = true;
                }
            })
            if (errors) {
                showErrors();
                return;
            }
            currentStep.classList.remove("active");
            currentStep.classList.add("disabled");

            currentStepTab.classList.remove("active");
            currentStepTab.classList.add("disabled");

            nextStep.classList.add("active");
            nextStep.classList.remove("disabled");

            nextStepTab.classList.add("active");
            nextStepTab.classList.remove("disabled");
        })
        let prevFormBtn = document.querySelector(".form .btn-prev-step")
        prevFormBtn.addEventListener("click", e => {
            let nextStep = document.querySelectorAll(".form .step1")
            let currentStep = document.querySelectorAll(".form .step2")
            currentStep.forEach(x => {
                x.classList.remove("active");
                x.classList.add("disabled");
            })
            nextStep.forEach(x => {
                x.classList.add("active");
                x.classList.remove("disabled");
            })
        })
    }
    let expandFade = document.querySelector(".expand-fade")

    if (expandFade) {
        let text = document.querySelector('.team-wrapper');

        if (text.clientHeight >= (window.innerHeight * 0.5)) {
            text.style.height = (window.innerHeight * 0.5) + "px";
            text.classList.add("hide");
            expandFade.classList.remove("d-none");
        }

    }
    $(expandFade).click(function () {
        $(this).css('opacity', 0);
        let text= $(".team-wrapper")
        // let text =expandFade.closest(".hide");
        
        let fullHeight = text.css('height', 'auto').height();
        text.css('height', (window.innerHeight * 0.5) + "px");
        text.animate({ height: fullHeight }, 500,null,()=>{
            text.removeClass("hide");    
        })
    })
    let resultBtn = document.querySelector(".load-results")
    if (resultBtn) {
        resultBtn.addEventListener("click", e => {
            //load more
            resultBtn.classList.add("disabled")
            fetch("/wp-admin/admin-ajax.php?action=results&s=" + resultBtn.dataset.term+"&paged="+resultBtn.dataset.page).then(res => res.json()).then(data => {
                document.querySelector(".result-row").innerHTML = data.html;//("beforeend", data.html)
                resultBtn.dataset.page = Number(resultBtn.dataset.page)+1;
                resultBtn.classList.remove("disabled")
                if(!data.more){
                    resultBtn.classList.add("d-none")
                }
            })
        })
    }

    let offerteBtn = document.querySelectorAll(".btn-offerte");
    if (offerteBtn.length > 0) {
        offerteBtn.forEach(x => {
            x.addEventListener("click", e => {
                document.querySelector(".slide-menu.offerte").classList.add("show")
                document.children[0].classList.add("hideHead")
            })
        })
        let closeFilterBtn = document.querySelector(".offerte-close")
        closeFilterBtn.addEventListener("click", e => {
            document.querySelector(".slide-menu.offerte").classList.remove("show")
            document.children[0].classList.remove("hideHead")
        })
    }
    let timeline= document.querySelector(".timeline")
    if(timeline){
        var swiper = new Swiper(timeline, {
            modules:[Navigation],
            slidesPerView: 1,
            grabCursor: true,
            navigation:{
                prevEl: '.prev-slide',
                nextEl: '.next-slide',
            },
            breakpoints:{
                1400:{
                    slidesPerView:5
                },
                1200:{
                    slidesPerView:4
                },
                992:{
                    slidesPerView:3
                },
                767:{
                    slidesPerView:2
                },
            }
        }); 
        window.slider=swiper;
    }
    document.querySelectorAll(".product-item-content .arrow-right").forEach(x=>{
        x.addEventListener("click",e=>{
            e.preventDefault();
            e.stopImmediatePropagation();
            window.location.href= x.closest("a").href+x.dataset.href;
        })
    })
});


